"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AREA", {
  enumerable: true,
  get: function get() {
    return _area.default;
  }
});
exports.ParseAddress = void 0;
Object.defineProperty(exports, "Utils", {
  enumerable: true,
  get: function get() {
    return _utils.default;
  }
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _area = _interopRequireDefault(require("./area"));
var _utils = _interopRequireDefault(require("./utils"));
var _parseArea = _interopRequireDefault(require("./parse-area"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } /**
 * address-parse
 * MIT License
 * By www.asseek.com
 */
class ParseAddress {
  constructor(address) {
    if (address) {
      return this.parse(address);
    }
  }

  /**
   * 开始解析
   * @param address string 地址
   * @param parseAll boolean 是否完全解析
   * @returns {Array}
   */
  parse(address, parseAll) {
    let results = [];
    if (address) {
      this.result = {
        mobile: "",
        zip_code: "",
        phone: ""
      };
      this.address = address;
      // console.log(111, this.address);

      this.replace();
      // console.log(222, this.address);
      this.parseMobile();
      // console.log(333, this.address);
      this.parsePhone();
      // console.log(444, this.address);
      this.parseZipCode();
      // console.log(555, this.address);
      // this.address = this.address.replace(/ {2,}/, " ");
      const firstName = ParseAddress.parseName({
        details: this.address
      });
      results = ParseAddress.ParseArea.parse(this.address, parseAll);
      var _iterator = _createForOfIteratorHelper(results),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          const result = _step.value;
          Object.assign(result, this.result);
          result.name = result.name.trim();
          ParseAddress.parseName(result, {
            firstName
          });
          ParseAddress.handlerDetail(result);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (!results.length) {
        const result = Object.assign(this.result, {
          province: "",
          city: "",
          area: "",
          details: this.address,
          name: "",
          code: "",
          __type: ""
        });
        ParseAddress.parseName(result);
        results.push(result);
      }
    }
    return results;
  }

  /**
   * 替换无效字符
   */
  replace() {
    let address = this.address;
    var _iterator2 = _createForOfIteratorHelper(ParseAddress.ExcludeKeys),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        const key = _step2.value;
        address = address.replace(new RegExp(key, "g"), " ");
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    this.address = address.replace(/\r\n/g, " ").replace(/\n/g, " ").replace(/\t/g, " ").replace(/ {2,}/g, " ").replace(/(\d{3})-(\d{4})-(\d{4})/g, "$1$2$3").replace(/(\d{3}) (\d{4}) (\d{4})/g, "$1$2$3");
  }

  /**
   * 提取手机号码
   */
  parseMobile() {
    ParseAddress.Reg.mobile.lastIndex = 0;
    const mobile = ParseAddress.Reg.mobile.exec(this.address);
    if (mobile) {
      this.result.mobile = mobile[0];
      this.address = this.address.replace(mobile[0], " ");
    }
  }

  /**
   * 提取电话号码
   */
  parsePhone() {
    ParseAddress.Reg.phone.lastIndex = 0;
    // console.log(this.address);
    const phone = ParseAddress.Reg.phone.exec(this.address);
    // console.log(phone);
    if (phone) {
      this.result.phone = phone[0];
      this.address = this.address.replace(phone[0], " ");
    }
  }

  /**
   * 提取邮编
   */
  parseZipCode() {
    ParseAddress.Reg.zipCode.lastIndex = 0;
    const zip = ParseAddress.Reg.zipCode.exec(this.address);
    if (zip) {
      this.result.zip_code = zip[0];
      this.address = this.address.replace(zip[0], "");
    }
  }

  /**
   * 提取姓名
   * @param result
   * @param maxLen 字符串占位 比这个数值短才识别为姓名 汉字2位英文1位
   * @param firstName 最初切分地址识别到的name
   */
  static parseName(result, {
    maxLen = 11,
    firstName
  } = {}) {
    if (!result.name || _utils.default.strLen(result.name) > 15) {
      const list = result.details.split(" ");
      const name = {
        value: "",
        index: -1
      };
      if (list.length > 1) {
        let index = 0;
        var _iterator3 = _createForOfIteratorHelper(list),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            const v = _step3.value;
            if (v && !name.value || v && _utils.default.strLen(name.value) > _utils.default.strLen(v) || firstName && v === firstName) {
              name.value = v;
              name.index = index;
              if (firstName && v === firstName) break;
            }
            index += 1;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      if (name.value) {
        result.name = name.value;
        list.splice(name.index, 1);
        result.details = list.join(" ").trim();
      }
    }
    return result.name;
  }

  /**
   * 清洗地址详情内的省市区
   * @param result
   */
  static handlerDetail(result) {
    if (result.details.length > 5) {
      const ary = ["province", "city", "area"];
      for (var _i = 0, _ary = ary; _i < _ary.length; _i++) {
        const key = _ary[_i];
        const index = result.details.indexOf(result[key]);
        if (index !== 0) continue;
        result.details = result.details.substr(result[key].length);
      }
    }
  }
}
exports.ParseAddress = ParseAddress;
(0, _defineProperty2.default)(ParseAddress, "ExcludeKeys", ["发件人", "收货地址", "收货人", "收件人",
// "收货",
"手机号码", "邮编", "电话", "所在地区", "详细地址", "地址", "：", ":", "；", ";", "，", ",", "。", "、"]);
(0, _defineProperty2.default)(ParseAddress, "ParseArea", new _parseArea.default());
(0, _defineProperty2.default)(ParseAddress, "Reg", _objectSpread({}, _utils.default.Reg));
var _default = exports.default = new ParseAddress();


//////////////////
// WEBPACK FOOTER
// ./node_modules/address-parse-cn/dist/parse/index.js
// module id = AqU6
// module chunks = 0